import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { getBasicInfo } from "../utils/api";
import { useState, useEffect } from "react";

const DEFAULT_LANGUAGE = "ja";

export const useBasicInfo = () => {
  const location = useLocation();
  const queryParams = useMemo(() => {
    return new URLSearchParams(location.search);
  }, [location.search]);

  const accountKey = queryParams.get("account") || null;

  const [state, setState] = useState({
    basicInfo: null,
    isLoading: true,
    isError: false,
  });

  const loadBasicInfo = async (accountKey) => {
    if (!accountKey) return;

    try {
      const basicInfo = await getBasicInfo(accountKey);
      setState((prev) => ({ ...prev, basicInfo, isError: false }));
    } catch (error) {
      console.error("Error loading basic info:", error);
      setState((prev) => ({ ...prev, isError: true }));
    } finally {
      setState((prev) => ({ ...prev, isLoading: false }));
    }
  };

  useEffect(() => {
    loadBasicInfo(accountKey);
  }, [accountKey]);

  return {
    work: state.basicInfo?.work,
    chapter: state.basicInfo?.chapter,
    lng: state.basicInfo?.lng,
    character: state.basicInfo?.character,
    visualStyle: state.basicInfo?.visualStyle,
    interactionType: state.basicInfo?.interactionType,
    soulId: state.basicInfo?.soulId,
    accountKey: accountKey,
    state: state.basicInfo?.state,
  };
};
